import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  return (
    <section className="bg-gradient-to-br from-[#D0E8F2] to-[#C4E5F4] py-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8">
            {/* Logo */}
            <div className="space-y-2">
              <img 
                src="https://customer-assets.emergentagent.com/job_sbrooks-expansion/artifacts/mk1xen7i_DjeZOVBfHiPd1kZxrGoFf%20%281%29.png" 
                alt="Brooks & Associates" 
                className="w-80 h-auto"
              />
            </div>

            {/* Tagline */}
            <div className="space-y-4">
              <h2 className="text-2xl md:text-3xl font-serif text-[#0A2540] font-bold">
                Empowering Your Financial Future
              </h2>
              <p className="text-base md:text-lg text-[#2C3E50] leading-relaxed">
                Personalized strategies in money management, insurance, and credit education.
              </p>
            </div>

            {/* CTA Button */}
            <Button 
              className="bg-[#0B8FD8] hover:bg-[#0973B0] text-white px-8 py-6 text-lg rounded-md transition-all duration-300 shadow-lg hover:shadow-xl"
              onClick={() => window.open('https://go.sbrooksassociatesllc.com/bookwithshannon', '_blank')}
            >
              Schedule Your Free Consultation
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.pexels.com/photos/4260096/pexels-photo-4260096.jpeg?auto=compress&cs=tinysrgb&w=800" 
                alt="Family financial planning"
                className="w-full h-auto object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
